import {GET_CASE_DETAILS_REQUEST, EDIT_CASE_DETAILS_REQUEST, CANCEL_CASE_REQUEST, GET_AVAILABLE_UNITS_REQUEST} from "./constants";
import {getCaseSuccess, getCaseFailure, editCaseSuccess, editCaseFailure, cancelCaseSuccess, cancelCaseFailure, getAvailableUnitsSuccess, getAvailableUnitsFailure} from "./actions";
import {call, put, takeLatest} from "redux-saga/effects";
import remote from "../../../../services/remote";
import SentryManager from "../../../../monitoring/Sentry";

function* getCaseDetails (action) {
    const url = `/bookings/get-booking/${action.caseId}`;
    try {
        const response = yield call(remote, {
            route: url,
            method: 'get'
        });
        if (response.success) {
            yield put(getCaseSuccess(response.data));
        } else {
            yield put(getCaseFailure(response));
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* editCaseDetails (action) {
    try {
        const response = yield call(remote, {
            route: "/bookings/edit-booking",
            method: 'put',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(editCaseSuccess(response.data));
        } else {
            yield put(editCaseFailure(response));
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* cancelCase (action) {
    try {
        const response = yield call(remote, {
            route: "/bookings/cancel-booking",
            method: 'delete',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(cancelCaseSuccess(response.data));
        } else {
            yield put(cancelCaseFailure(response));
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* getAvailableUnits (action) {
    try {
        const response = yield call(remote, {
            route: "/bookings/get-available-units",
            method: 'post',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(getAvailableUnitsSuccess(response.data));
        } else {
            yield put(getAvailableUnitsFailure(response));
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

export default function* watchCaseDetails() {
    yield takeLatest(CANCEL_CASE_REQUEST , cancelCase);
    yield takeLatest(GET_CASE_DETAILS_REQUEST , getCaseDetails);
    yield takeLatest(EDIT_CASE_DETAILS_REQUEST , editCaseDetails);
    yield takeLatest(GET_AVAILABLE_UNITS_REQUEST , getAvailableUnits);
}


// WEBPACK FOOTER //
// ./src/containers/Layouts/User/CaseDetails/saga.js